// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const seedot: PokeData = {
  "id": 273,
  "name": "seedot",
  "height": 5,
  "weight": 40,
  "base_experience": 44,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "absorb",
    "mega-drain",
    "growth",
    "harden",
    "bide",
    "explosion",
    "rollout",
    "synthesis",
    "sunny-day",
    "nature-power",
    "astonish",
    "payback",
    "sucker-punch"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "synthesis",
    "sunny-day",
    "power-whip",
    "frenzy-plant",
    "vine-whip",
    "grassy-terrain",
    "energy-ball",
    "aromatherapy",
    "wood-hammer",
    "bullet-seed",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 137,
    "item": null,
    "species": [
      {
        "name": "seedot",
        "order": 298,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "nuzleaf",
        "order": 299,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 273,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "shiftry",
        "order": 300,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": 274,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 30,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
